import CryptoJS from "crypto-js";
export default class CryptoService {
    // @ts-ignore
    static secretKey = process.env.VUE_APP_CRYPTO_SECRET;
    static encode(value) {
        return CryptoJS.AES.encrypt(value, this.secretKey);
    }
    static decode(value) {
        return CryptoJS.AES.decrypt(value, this.secretKey).toString(CryptoJS.enc.Utf8);
    }
}
